module.exports = "./img/28cdfe8471ff03b1a49752a5b6541a65.jpg";